module.exports = __webpack_public_path__ + "img/face logo.0df7ebdc.png";